import { ActionTree } from 'vuex'
import { CarSpecificationState } from './types';
import { RootState } from '@/store/types';

export const actions: ActionTree<CarSpecificationState, RootState> = {
}
